const content = {
   google_takeout_multi_file: {
       en: {
           summary_no_video_html: `
           <h2>Before you start</h2> 
           <p>It's important you complete each step, or we won't be able to process your payment! Our
             instructions are easy to follow.</p>`,
           steps: [
               {
                   step_type: 'numbered_step',
                   number: '1',
                   description_html: `
               <p>Go to Google Takeout.</p>`
               },
               {
                   step_type: 'numbered_step',
                   number: '2',
                   description_html: `
               <p>Request your files.</p>`
               },
               {
                   step_type: 'numbered_step',
                   number: '3',
                   description_html: `
               <p>Upload the files.</p>`
               }
           ]
       }
   }
}

export const googleTakeoutMultiDataTypes = {
    google_takeout_multi_file: {
        data_type: 'google_takeout_multi_file',
        data_type_description: 'Walmart Orders',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: false,
        generic: {
        },
        generic: {
            ...content.google_takeout_multi_file
        }
    },
}